var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9D2BBEB4-31D4-443A-8F5C-9D56E9EC9886") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.666667,564.386111 C105.666667,564.211111 105.597222,564.041667 105.472222,563.916667 L102.752778,561.194444 C102.627778,561.069444 102.458333,561 102.280556,561 L102.111111,561 L102.111111,564.555556 L105.666667,564.555556 L105.666667,564.386111 Z M100.333333,570.333333 L100.333333,569.444444 C100.333333,569.198889 100.532222,569 100.777778,569 L105.666667,569 L105.666667,565.444444 L101.888889,565.444444 C101.522222,565.444444 101.222222,565.144444 101.222222,564.777778 L101.222222,561 L95.6666667,561 C95.2972222,561 95,561.297222 95,561.666667 L95,574.555556 C95,574.925 95.2972222,575.222222 95.6666667,575.222222 L105,575.222222 C105.369444,575.222222 105.666667,574.925 105.666667,574.555556 L105.666667,570.777778 L100.777778,570.777778 C100.532222,570.777778 100.333333,570.578889 100.333333,570.333333 Z M110.8625,569.555 L108.204167,566.876389 C107.924722,566.594722 107.444167,566.792778 107.444167,567.189444 L107.444167,569 L105.666667,569 L105.666667,570.777778 L107.444167,570.777778 L107.444167,572.588333 C107.444167,572.985 107.924444,573.183056 108.204167,572.901389 L110.8625,570.223056 C111.045833,570.038056 111.045833,569.739722 110.8625,569.555 L110.8625,569.555 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-KIt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-95.000000, -561.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "file-export",
    fill: "var(--tru-grey-200)",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExport);
export default ForwardRef;